import { Phone, Mail, Clock } from "lucide-react";
import { business } from "@/data/site";
import { Reveal } from "./motion";

export const Contact = () => (
  <section
    id="contact"
    data-testid="contact-section"
    className="relative z-10 bg-[#1C1C1C] pt-12 sm:pt-16 pb-16 sm:pb-20"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
      <Reveal className="lg:col-span-5">
        <p className="text-xs tracking-[0.3em] uppercase text-[#FF4500] font-bold mb-4">
          Get In Touch
        </p>
        <h2 className="font-display font-bold uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
          Let's talk about your move
        </h2>
        <p className="mt-6 text-neutral-400 leading-relaxed max-w-md">
          The fastest way to get moving is to reach out. Call, text, or send a
          quote request — we respond quickly.
        </p>
        <a
          href="#quote"
          data-testid="contact-quote-btn"
          className="mt-8 inline-flex items-center gap-2 bg-[#FF4500] text-[#1C1C1C] font-bold px-8 py-4 hover:bg-[#E03C00] transition-colors"
        >
          Request a Quote
        </a>
      </Reveal>

      <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Reveal delay={0.05}>
          <a
            href={`tel:${business.phone}`}
            data-testid="contact-phone"
            className="group flex flex-col gap-3 border border-[#3d3d3d] bg-[#303030] p-8 h-full hover:border-[#FF4500]/60 transition-colors"
          >
            <Phone className="h-7 w-7 text-[#FF4500]" strokeWidth={1.5} />
            <span className="text-xs uppercase tracking-widest text-neutral-300">Call / Text</span>
            <span className="font-display font-bold text-xl">{business.phone}</span>
          </a>
        </Reveal>
        <Reveal delay={0.1}>
          <a
            href={`mailto:${business.email}`}
            data-testid="contact-email"
            className="group flex flex-col gap-3 border border-[#3d3d3d] bg-[#303030] p-8 h-full hover:border-[#FF4500]/60 transition-colors"
          >
            <Mail className="h-7 w-7 text-[#FF4500]" strokeWidth={1.5} />
            <span className="text-xs uppercase tracking-widest text-neutral-300">Email</span>
            <span className="font-semibold text-base break-all">{business.email}</span>
          </a>
        </Reveal>
        <Reveal delay={0.15} className="sm:col-span-2">
          <div
            data-testid="contact-hours"
            className="flex flex-col gap-3 border border-[#3d3d3d] bg-[#303030] p-8 h-full"
          >
            <Clock className="h-7 w-7 text-[#FF4500]" strokeWidth={1.5} />
            <span className="text-xs uppercase tracking-widest text-neutral-300">Hours</span>
            <p className="text-sm sm:text-base text-neutral-300 leading-relaxed">
              By appointment, 7 days a week. Call or text to schedule.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
